import { render } from "./RuiDate.vue?vue&type=template&id=31b0b883&scoped=true"
import script from "./RuiDate.vue?vue&type=script&lang=ts"
export * from "./RuiDate.vue?vue&type=script&lang=ts"

import "./RuiDate.vue?vue&type=style&index=0&id=31b0b883&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31b0b883"

export default script